import {store} from '@/store/store'
import {ajaxUtil} from './AjaxUtil'

var api = {}
api.movie = '/userApp/rankingList/borrow';
var imgPath = document.location.protocol+"//img.ytsg.com/";
/**
 * 首页接口
 */
api.index = {};

api.index.ranking ="/userApp/rankingList/homeRankingWeb?libCode={libCode}";
api.index.hotEbooks ="/userApp/ebook/queryHotEbooks";
api.index.recommendEbooks ="/userApp/ebook/queryRecommendEbooks?categoryId={categoryId}";
api.index.htEbookType ="/userApp/ebook/queryHotType";
api.index.recommendGoodEBooks="/userApp/ebook/recommendGoodEBooks?pageNo={pageNo}&pageCount={pageCount}";

/**
 * 资讯接口
 */
api.information = {};
api.information.search = "/userApp/news/newsList/region?pageNo={pageNo}&pageCount={pageCount}&locationCode={locationCode}";
api.information.info = '/userApp/news/info?fromSearch={fromSearch}&identity={identity}&newsId={newsId}';
api.information.praise = '/userApp/news/praise?identity={identity}&newsId={newsId}';

//资讯评论
api.news = {};
api.news.commentList = '/userApp/news/commentList?identity={identity}&newsId={newsId}&pageCount={pageCount}&pageNo={pageNo}&readerId={readerId}&isPage=1';
api.news.commentPraise = 'userApp/news/commentPraise?commentId={commentId}&identity={identity}';
api.news.pubReply = '/userApp/news/pubReply';
//发布评论
api.news.pubComment = '/userApp/news/pubComment';
//评论回复点赞
api.news.replyPraise='/userApp/news/replyPraise?identity={identity}&replyId={replyId}';
//删除资讯评论
api.news.delComment='userApp/news/delComment';
///删除回复
api.news.delReply='userApp/news/delReply';
/*//评论详情
api.news.commentInfo*/
/**
 * 活动接口
 */
api.activity = {};
api.activity.activitys="/userApp/activity/activities/{libCode}?keyword={keyword}&pageNo={pageNo}&pageCount={pageCount}";
api.activity.search ="/userApp/activity/activities/region?pageNo={pageNo}&pageCount={pageCount}&locationCode={locationCode}&keyword={keyword}";
api.activity.info='/userApp/activity/info?activityId={activityId}&idCard={idCard}';
api.activity.apply='/userApp/activity/apply?activityId={activityId}&idCard={idCard}';
api.activity.readerApplyeds='/userApp/activity/applyList';



api.ranking = {};
//借阅排行榜
api.ranking.borrowRanking = '/userApp/rankingList/borrowRankingNew?pageNo={pageNo}&pageCount={pageCount}&sortType={sortType}';
//点赞排行榜
api.ranking.praiseRanking = '/userApp/rankingList/praiseRankingNew?pageNo={pageNo}&pageCount={pageCount}&sortType={sortType}';
//推荐排行榜
api.ranking.recommendRanking = '/userApp/rankingList/recommendRankingNew?pageNo={pageNo}&pageCount={pageCount}&sortType={sortType}';
//阅读排行榜
api.ranking.ebookRanking = '/userApp/rankingList/ebookRankingNew?pageNo={pageNo}&pageCount={pageCount}&sortType={sortType}';

//图书馆
api.area = {};
//省列表
api.area.province = '/userApp/area/province';
//市列表
api.area.city = '/userApp/area/city?provinceCode={provinceCode}';
//区列表
api.area.area = '/userApp/area/area?cityCode={cityCode}';
//管别
api.area.level = '/userApp/library/level';


api.library = {};
api.library.regulation = '/userApp/library/otherProvisions/{libCode}';
api.library.libraryNumber ='/userApp/library/number?libCode={libCode}';
//图书馆高级搜索
api.library.list = '/userApp/library/list?lngLat={lngLat}&pageCount={pageCount}&pageNo={pageNo}&locationCode={locationCode}&flag='+'web'+'';

//图书馆详情
api.library.info = '/userApp/library/info?fromSearch={fromSearch}&flag={flag}&libId={libId}&lngLat={lngLat}';
api.library.infoData = '/userApp/library/number?libCode={libCode}'

//图书馆开放设置
api.library.libLight = '/userApp/library/libLight?libCode={libCode}';
//获取其他规定
api.library.otherProvisions = '/userApp/library/otherProvisions/{libCode}';
//获取馆的上级，分馆数量
api.library.number = '/userApp/library/number?libCode={libCode}';
//获取馆的上级馆数量
api.library.supLibrary = '/userApp/library/supLibrary?libCode={libCode}&lngLat={lngLat}&pageCount={pageCount}&pageNo={pageNo}';
//获取馆的分馆数量
api.library.branchLibrary = '/userApp/library/branchLibrary?libCode={libCode}&lngLat={lngLat}&pageCount={pageCount}&pageNo={pageNo}';

//获取图书馆的上级馆，一级馆，二极管
//api.library.getAllLibrary='userApp/library/getAllLibrary?libCode={libCode}&lngLat={lngLat}&pageNo={pageNo}&pageCount={pageCount}';

api.library.getAllLibrary = 'userApp/library/getSubLibrarys?libCode={libCode}&lngLat={lngLat}'
//获取一级馆
api.library.getOneLevelLibrary='userApp/library/getOneLevelLibrary?libCode={libCode}&lngLat={lngLat}&pageNo={pageNo}&pageCount={pageCount}';
//获取二级管
api.library.getTwoLevelLibrary='userApp/library/getTwoLevelLibrary?libCode={libCode}&lngLat={lngLat}&pageNo={pageNo}&pageCount={pageCount}';

//图书馆资讯
// api.library.libNews = '/userApp/news/libNews?pageNo={pageNo}&pageCount={pageCount}';
api.library.libNews = '/userApp/news/newsList/{libCode}?pageCount={pageCount}&pageNo={pageNo}';
//图书馆读者留言列表
api.library.msgList='/userApp/library/messageList?pageNo={pageNo}&pageCount={pageCount}&readerId={readerId}&libCode={libCode}';
api.library.messageReplyList='/userApp/library/messageReplyList?pageNo={pageNo}&pageCount={pageCount}&readerId={readerId}&messageId={messageId}';
//读者留言
api.library.pubMsg='/userApp/library/pubMsg';
//删除留言
api.library.delMsg='/userApp/library/delMsgAndPraiseAndReply';
//第三方授权
api.auth = {};
api.auth.ticket='/userApp/auth/ticket';
/**
 * 图书
 */
api.book = {};
api.book.category = '/userApp/libraryBook/category';
api.book.borrowing = '/userApp/libraryBook/{libCode}?pageNo={pageNo}&pageCount={pageCount}&categoryId={categoryId}'
api.book.weeklyHot = '/userApp/libraryBook/weeklyHot?pageNo={pageNo}&pageCount={pageCount}&categoryId={categoryId}';
api.book.lastestCatalogue = '/userApp/libraryBook/lastestCatalogue?pageNo={pageNo}&pageCount={pageCount}&categoryId={categoryId}';
api.book.libCode = '/userApp/libraryBook/{libCode}?pageNo={pageNo}&pageCount={pageCount}&categoryId={categoryId}';
api.book.search = '/userApp/libraryBook/search?pageNo={pageNo}&pageCount={pageCount}';
// api.book.info = '/userApp/libraryBook/bookInfo?isbn={isbn}';
api.book.info = '/userApp/libraryBook/bookInfo?isbn={isbn}&hallCode={hallCode}';
api.book.stayLibrarys = '/userApp/libraryBook/bookStayLibraryAllInfo?isLibCode=1&pageNo={pageNo}&pageCount={pageCount}&isbn={isbn}&customerScope={customerScope}';
api.book.getStoreRoom = 'userApp/libraryBook/getStoreRoom?libCode={libCode}'
api.book.getBelongLibrary = '/userApp/libraryBook/bookStayLibraryAllInfo?isbn={isbn}&libCode={libCode}'
api.book.getBelongLibrary = '/userApp/libraryBook/bookStayLibraryAllInfo?isbn={isbn}&libCode={libCode}'
api.book.recommendGoodBooks ='/userApp/libraryBook/recommendGoodBooks?pageNo={pageNo}&pageCount={pageCount}&categoryId={categoryId}&libCode={libCode}'


/**
 * 电子书
 */
api.ebook = {};
api.ebook.category = '/userApp/ebook/category/all';
api.ebook.weeklyHot = '/userApp/ebook/weeklyHot?pageNo={pageNo}&pageCount={pageCount}&categoryId={categoryId}';
api.ebook.lastestCatalogue = '/userApp/ebook/lastestCatalogue?pageNo={pageNo}&pageCount={pageCount}&oneLevelCategoryId={oneLevelCategoryId}';
api.ebook.libCode = '/userApp/ebook/{libCode}?pageNo={pageNo}&pageCount={pageCount}&categoryId={categoryId}';
api.ebook.search = '/userApp/ebook/search?pageNo={pageNo}&pageCount={pageCount}';
api.ebook.info = '/userApp/ebook/info?id={id}&hallCode={hallCode}';
api.ebook.addEbookReadRecord = 'userApp/ebook/addEbookReadRecord';
api.ebook.belongLibrary = '/userApp/ebook/belongLibrary?ebookId={ebookId}&lngLat={lngLat}&readerId={readerId}';
api.ebook.collections = '/userApp/ebook/ebookFavorites/{readerId}?pageNo={pageNo}&pageCount={pageCount}';//电子书收藏列表
api.ebook.collectionSave = '/userApp/ebook/ebookFavorites';//电子书收藏保存
api.ebook.collectionCancel = '/userApp/ebook/cancelEbookFavorites';//电子书收藏取消
api.ebook.collectionStatus = '/userApp/ebook/favorStatus/{ebookId}/{readerId}';//电子书收藏状态
api.ebook.recommendGoodEBooks='/userApp/ebook/recommendGoodEBooks?pageNo={pageNo}&pageCount={pageCount}&oneLevelCategoryId={oneLevelCategoryId}';


/**
 * 预约
 */
api.reservation = {};
api.reservation.list = '/userApp/reader/appointList?idCard={idCard}&pageCount={pageCount}&pageNo={pageNo}';
api.reservation.appoint = '/userApp/reader/appoint';
api.reservation.appointByBackstage = '/userApp/reader/appointByBackstage';
api.reservation.getAppointStaus = '/userApp/reader/getAppointStaus?readerId={readerId}&libCode={libCode}&isbn={isbn}';


//读者
api.reader = {};
api.reader.login = '/userApp/reader/login';
api.reader.authorityLogin = '/userApp/reader/authorityLogin';
api.reader.checkIdCard = '/userApp/reader/checkIdCard?idCard={idCard}';
//修改密码
api.reader.updatePassword='/userApp/reader/updatePassword';

//验证手机号与code(忘记密码个人中心)
api.reader.resetValidPhoneCode = 'userApp/reader/resetValidPhoneCode';
//重置密码
api.reader.resetPassword = '/userApp/reader/resetPassword';
//判断手机号是否注册
api.reader.preUserInfo='/userApp/reader/preUserInfo?phone={phone}';
//修改/绑定手机号时发送短信
api.reader.modifySend='/userApp/sms/modifySend';
//修改/绑定手机号（提交）
api.reader.modifyPhone='/userApp/reader/modifyPhone';
//提交注册
api.reader.register='/userApp/reader/register';
//修改/绑定手机时校验验证码
api.reader.checkCodeByModifyPhone='/userApp/reader/checkCodeByModifyPhone?phone={phone}&code={code}';
//检查读者是否有电子书阅读权限
api.reader.checkReaderEbook = '/userApp/ebook/checkReaderAuthority/{hallCode}/{readerId}'
//添加读者其权限
api.reader.addReaderAuthority= '/userApp/ebook/addReaderAuthority'
//发送短信
api.sms = {};
//注册发送短信
api.sms.registerSend = '/userApp/sms/registerSend';
//手机号注册step2-校验验证码-
api.sms.checkCode = '/userApp/reader/checkCode?code={code}&phone={phone}';


//个人中心
api.personal = {}

api.personal.getUnreadcount = '/userApp/reader/unreadCount';
//验证身份证号(忘记密码)
api.personal.validPhone = '/userApp/reader/validPhone?idCard={idCard}';
//发送短信(忘记密码)
api.personal.sms = 'userApp/sms/resetPwdSend';
//读者信息
api.reader.info='userApp/reader/readerInfo?id={id}';

//我的消息
api.personalnews = {};
api.personalnews.overdue = '/userApp/overdue/getMessageCountByIdCard?idCard={idCard}' //未读逾期消息
api.personalnews.overdueList = '/userApp/overdue/queryReaderMessagesByIdCard?idCard={idCard}&pageCount={pageCount}&pageNo={pageNo}' //未读其他消息
api.personalnews.overdueUpdateStatus = '/userApp/overdue/updateStatus' //逾期消息修改状态

api.personalnews.myMessage = '/userApp/reader/myMessage'; //其他消息列表
api.personalnews.readMsg = '/userApp/reader/readMsg'; //读取其他消息

api.personalnews.replayComment = '/userApp/news/pubReply'; //我的消息回复评论
api.personalnews.commentIndex = '/userApp/reader/commentIndex?commentId={commentId}'; //消息索引值
//读书笔记
api.note = {};
api.note.list = '/userApp/reader/notes?idCard={idCard}&pageCount={pageCount}&pageNo={pageNo}'; //笔记列表
api.note.noteDetail = '/userApp/reader/getNotesByBookIdAndReaderId?readerId={readerId}&bookId={bookId}'; //笔记详情
api.note.update = '/userApp/reader/updateNote'; //笔记修改
api.note.add = '/userApp/reader/addNote'; //笔记新增
api.note.delNote = '/userApp/reader/delNote';  //笔记删除
//借阅信息
api.readerBorrower = {};
api.readerBorrower.list = '/userApp/readerBorrower/borrowList?idCard={idCard}&pageCount={pageCount}&pageNo={pageNo}&borrowType={borrowType}'; //借阅列表
api.readerBorrower.like = '/userApp/reader/support'; //点赞
api.readerBorrower.renew = '/userApp/readerBorrower/renew'; //一键续借
//借阅信息
api.account= {};
api.account.getDepositInfo ='/api/libraryreader/getDepositInfo?hallCode={hallCode}&readerId={readerId}'; //获取读者押金信息
api.account.compensateOneBook ='/api/libraryreader/{readerId}/compensateOneBook'; //赔书

//访问量
api.readNumber={};
api.readNumber.visitNum='/userApp/VisitNum/updateVisitNum';

api.getLibrary = {};
api.getLibrary.info = '/userApp/library/getLibrary?hallCode={hallCode}';


var msg = {
  emptyInput: '输入不能为空!',
  emptyInputAccount: '账号不能为空!',
  emptyInputPass: '密码不能为空!',
  accountExist: "账号不存在!",
  passError:'密码错误!',
  phoneRepetition:'与原号码重复!',
  phoneExist:'手机已存在!',
  phoneError:'手机号错误!',
  codeError:'验证码错误!',
  updatePhoneError:'修改手机号失败!',
  updatePhoneSuccess:'修改手机号成功!',
  sendCode:'验证码已发送!',
  sendCodeError:'验证码发送失败!',
  passDisaccord:'新密码不一致!',
  passCountError:'密码必须为6位!',
  idCardError:'身份证号错误！',
  unregistered:'身份证号未注册！',
  idCardExist:'身份证号已经存在!',
};

var menusConfigsPlatforms = [
  { name: '首页',url: '/',}, { name: '图书馆',url: '/librarylist',},
  { name: '图书',url: '/book/1',}, { name: '电子书',url: '/book/2',},
  { name: '资讯',url: '/informationlist',}, { name: '活动',url: '/activitylist',},
  { name: '排行榜',url: '/ranklist',}
];


var menusConfigsLibrary = [
    { name: '首页',url: '/',}, { name: '本馆介绍',url: '/webintroduce',},
    { name: '图书',url: '/book/1',}, { name: '电子书',url: '/book/2',},
    { name: '资讯',url: '/informationlist',}, { name: '活动',url: '/activitylist',},
    { name: '总分馆',url: '/librarypart',},
    { name: '读者留言',url: '/readercomments',}
];


function getLibraryInfo(hallCode,app) {
  return new Promise((resolve, reject)=>{
    ajaxUtil.ajaxJson(api.getLibrary.info.replace('{hallCode}',hallCode),null,"GET",(data)=>{
      resolve(data)
    },(err)=>{
      reject(err)
    },app)
  })
}
function getLibraryIsPart(hallCode,app) {
    return new Promise((resolve, reject)=> {
        var url = api.library.getAllLibrary.replace('{libCode}', hallCode).replace('{lngLat}',store.localtionArea.latLng).replace('{pageNo}', 1).replace('{pageCount}', 3);
        ajaxUtil.ajaxJson(url, null, "GET", (data) => {
            resolve(data)
        },(err)=>{
            reject(err)
        },app)
    })
}


export {api, msg,imgPath, menusConfigsPlatforms,menusConfigsLibrary,getLibraryInfo,getLibraryIsPart}
